import { render } from "./App.vue?vue&type=template&id=6a6d7e9c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6a6d7e9c&lang=scss"
import "./App.vue?vue&type=style&index=1&id=6a6d7e9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a6d7e9c"

export default script